import React, { useState } from 'react';
import styles from './DevPasscodeModal.module.css';

interface DevPasscodeModalProps {
  isOpen: boolean;
  onSuccess: () => void;
  onCancel: () => void;
}

const DevPasscodeModal: React.FC<DevPasscodeModalProps> = ({
  isOpen,
  onSuccess,
  onCancel,
}) => {
  const [passcode, setPasscode] = useState('');
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Import the verification function
    import('../../utils/devPasscode').then(({ verifyDevPasscode, grantDevAccess }) => {
      if (verifyDevPasscode(passcode)) {
        grantDevAccess();
        setError('');
        setPasscode('');
        onSuccess();
      } else {
        setError('Invalid passcode');
        setPasscode('');
      }
    });
  };

  const handleCancel = () => {
    setPasscode('');
    setError('');
    onCancel();
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2 className={styles.title}>Developer Access</h2>
        <p className={styles.description}>
          Enter the developer passcode to access the developer interface
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            className={styles.passcodeInput}
            value={passcode}
            onChange={(e) => setPasscode(e.target.value)}
            placeholder="Enter passcode"
            autoFocus
            maxLength={10}
          />

          {error && <div className={styles.error}>{error}</div>}

          <div className={styles.buttonGroup}>
            <button type="submit" className={styles.submitButton}>
              Submit
            </button>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DevPasscodeModal;
